const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image['src'])
  return widths
    .filter((width) => width <= image['width'])
    .map((width) => {
      imageUrl.searchParams.set('width', width.toString())
      return `${imageUrl.href} ${width}w`
    })
    .join(', ')
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image['preview_image']
  const newImage = new Image(previewImage['width'], previewImage['height'])
  newImage.className = classes
  newImage.alt = image['alt'] || productTitle
  newImage.sizes = sizes
  newImage.src = previewImage['src']
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066])
  newImage.loading = 'lazy'
  return newImage
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector('.media--first')
        const secondaryImage = wrapper.querySelector('.media--second')
        const handleProduct = wrapper.dataset.product

        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink)
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false)
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden')
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden')
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId
          }

          // Trigger variant recalculation if product-card-variants element exists
          const productCardVariants = wrapper.querySelector('product-card-variants')
          if (productCardVariants && productCardVariants.onVariantChange) {
            productCardVariants.onVariantChange()
          }

          const currentColor = event.currentTarget.value

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
            const variant = product.variants.filter(
              (item) => item.featured_media != null && item.options.includes(currentColor)
            )[0]

            if (variant) {
              const newPrimaryImage = createImageElement(
                variant['featured_media'],
                primaryImage.className,
                primaryImage.sizes,
                product.title
              )

              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove()
                    secondaryImage.classList.remove('media--second')
                    secondaryImage.classList.add('media--first')
                    flag = true
                  }
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: 'ease-in', fill: 'forwards' })
                    .finished
                  setTimeout(function () {
                    primaryImage.replaceWith(newPrimaryImage)
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' })
                    if (secondaryImage) {
                      secondaryImage.remove()
                    }
                  }, 200)
                }
              }
            }
          })
        }
      })
    })

    // Add click/touch handler to swatch labels to navigate to product page with variant
    wrapper.querySelectorAll('.js-color-swatches label.color-swatch').forEach((label) => {
      const handleSwatchClick = (event) => {
        const input = document.getElementById(label.getAttribute('for'))
        if (input && input.dataset.variantLink) {
          // Prevent default radio button behavior
          event.preventDefault()
          event.stopPropagation()
          // Navigate to the product page with the selected variant
          window.location.href = input.dataset.variantLink
        }
      }

      // Handle both click and touch events for better mobile support
      label.addEventListener('click', handleSwatchClick)
      label.addEventListener('touchend', handleSwatchClick)
    })
  })
}

function colorSwatches() {
  checkSwatches()

  document.addEventListener('shopify:section:load', function () {
    checkSwatches()
  })
}

// Custom element to handle variant selection in product cards
if (!customElements.get('product-card-variants')) {
  customElements.define(
    'product-card-variants',
    class ProductCardVariants extends HTMLElement {
      constructor() {
        super()
        this.variantData = null
        this.init()
      }

      init() {
        // Get variant data from the JSON script tag
        const variantDataElement = this.querySelector('[data-variants]')
        if (variantDataElement) {
          this.variantData = JSON.parse(variantDataElement.textContent)
        }

        // Listen for changes on all radio inputs (size, etc.)
        this.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.addEventListener('change', () => this.onVariantChange())
        })

        this.refreshOptionStates()
      }

      onVariantChange() {
        // Get all selected options from the fieldsets
        const selectedOptions = this.getSelectedOptions()

        console.log('[product-card-variants] Selected options:', selectedOptions)

        if (!selectedOptions || selectedOptions.length === 0) {
          return
        }

        // Find the variant that matches all selected options
        const matchingVariant = this.findMatchingVariant(selectedOptions)

        console.log('[product-card-variants] Matching variant:', matchingVariant)

        if (matchingVariant) {
          this.updateVariantId(matchingVariant.id)
          console.log('[product-card-variants] Updated variant ID to:', matchingVariant.id)
        }

        this.refreshOptionStates()
      }

      getSelectedOptions() {
        const options = []

        // First, always add all options from ALL variants that are common
        // This ensures we capture the color even if it's not explicitly selected
        if (this.variantData && this.variantData.length > 0) {
          // Get options that are the same across ALL variants (like the color for this product)
          const firstVariant = this.variantData[0]
          if (firstVariant && firstVariant.options) {
            firstVariant.options.forEach((optionValue, index) => {
              // Check if this option value is the same across all variants
              const isConsistentOption = this.variantData.every((v) => v.options[index] === optionValue)
              if (isConsistentOption) {
                // This is a consistent option (like color), add it
                options.push(optionValue)
              }
            })
          }
        }

        // Check if we're in a quick-add modal
        const quickAddModal = this.closest('quick-add-modal')
        const cardWrapper = this.closest('.card-wrapper')

        // If not in modal, check for color swatches in the card wrapper
        if (!quickAddModal && cardWrapper) {
          const colorSwatch = cardWrapper.querySelector('.js-color-swatches input:checked')
          if (colorSwatch && !options.includes(colorSwatch.value)) {
            options.push(colorSwatch.value)
          }
        }

        // Get selected options from this form's fieldsets (size, etc.)
        this.querySelectorAll('fieldset').forEach((fieldset) => {
          const checkedInput = fieldset.querySelector('input[type="radio"]:checked')
          if (checkedInput && !options.includes(checkedInput.value)) {
            options.push(checkedInput.value)
          }
        })

        return options
      }

      findMatchingVariant(selectedOptions) {
        if (!this.variantData || !selectedOptions || selectedOptions.length === 0) {
          return null
        }

        // Find variant where all selected options are present in the variant's options
        return this.variantData.find((variant) => {
          return selectedOptions.every((selectedOption) => variant.options.includes(selectedOption))
        })
      }

      updateVariantId(variantId) {
        // Find all forms in the modal/card and update variant ID
        const quickAddModal = this.closest('quick-add-modal')
        const cardWrapper = this.closest('.card-wrapper')

        let targetElement = quickAddModal || cardWrapper

        if (!targetElement) {
          // Fallback: try to find forms globally
          targetElement = document
        }

        // Update all forms with the new variant ID
        const forms = targetElement.querySelectorAll('form[data-type="add-to-cart-form"]')
        forms.forEach((form) => {
          const variantInput = form.querySelector('input[name="id"]')
          if (variantInput) {
            variantInput.value = variantId
          }
        })
      }

      refreshOptionStates() {
        if (!this.variantData || !this.variantData.length) return

        const selectedOptions = this.getSelectedOptions()
        const totalOptions = this.variantData[0]?.options?.length || 0
        if (!totalOptions) return

        const fieldsets = Array.from(this.querySelectorAll('fieldset'))
        fieldsets.forEach((fieldset, optionIndex) => {
          const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
          if (!inputs.length) return

          let checkedInput = inputs.find((input) => input.checked)

          inputs.forEach((input) => {
            const optionValue = input.value
            const testSelection = selectedOptions.slice(0, totalOptions)
            testSelection[optionIndex] = optionValue

            const hasAvailableVariant = this.variantData.some((variant) => {
              if (!variant || !variant.options) return false
              if (!variant.available) return false
              return variant.options.every((variantOptionValue, idx) => {
                const selectedValue = testSelection[idx]
                return !selectedValue || variantOptionValue === selectedValue
              })
            })

            input.classList.toggle('disabled', !hasAvailableVariant)
            if (!hasAvailableVariant) {
              input.setAttribute('aria-disabled', 'true')
            } else {
              input.removeAttribute('aria-disabled')
            }
            const label = fieldset.querySelector(`label[for="${input.id}"]`)
            if (label) {
              label.classList.toggle('out-of-stock', !hasAvailableVariant)
            }
          })

          if (checkedInput && checkedInput.classList.contains('disabled')) {
            const fallbackInput = inputs.find((input) => !input.classList.contains('disabled'))
            if (fallbackInput && fallbackInput !== checkedInput) {
              checkedInput.checked = false
              fallbackInput.checked = true
              setTimeout(() => {
                fallbackInput.dispatchEvent(new Event('change', { bubbles: true }))
              }, 0)
            }
          }
        })
      }
    }
  )
}

;(function () {
  colorSwatches()
})()
